import {
  Box,
  Button,
  makeStyles,
  Typography,
  CardMedia,
} from "@material-ui/core";
import React from "react";
import { useHistory } from "react-router-dom";
//import InsertEmoticonIcon from "@material-ui/icons/InsertEmoticon";
import HelpIcon from "@material-ui/icons/Help";
import { useTranslate } from "react-admin";
//import EmojiEmotionsIcon from "@material-ui/icons/EmojiEmotions";
import MemberIcon from "../../assets/member.png";
import SfBreadcrumbs from "../../components/SfBreadcrumbs";
import PermissionChecker from "../../components/PermissionChecker";
const useStyles = makeStyles((theme) => ({
  allContainer: {
    display: "flex",
    flexDirection: "column",
  },
  buttonContainer: {
    width: 278,
    margin: "auto 50px",
    height: 278,
    backgroundColor: theme.orange,
    boxShadow:
      " -5px 3px 7px 2px rgba(0, 0, 0, 0.25), inset 0px 4px 4px rgba(0, 0, 0, 0.25)",
    borderRadius: 21,
    "&:hover": {
      backgroundColor: theme.orange,
    },
  },
  topContainer: {
    display: "flex",
    flexDirection: "column",
  },
  breadcrumb: {
    marginTop: 15,
  },
  topics: {
    marginTop: 50,
    fontSize: 28,
    // fontWeight: "bolder",
    alignSelf: "center",
  },
  bigIconwithTextContainer_icon: { width: 112, height: 112 },
  mLeft: {},
  textStyle: {
    fontSize: "28px",
    lineHeight: "38px",
    display: "flex",
    alignItems: "center",
    textAlign: "center",
    justifyContent: "center",
    marginTop: 18,
    color: theme.pureWhite,
    fontWeight: 700,
  },
  container: {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    marginTop: 83,
  },
  icon: { color: theme.pureWhite, height: 112, width: 112 },
}));

function CustomerInsightPage() {
  const classes = useStyles();
  const history = useHistory();
  const translate = useTranslate();
  return (
    <Box className={classes.allContainer}>
      <Box className={classes.topContainer}>
        <SfBreadcrumbs path="/Customer insight" lower />
        <Typography className={[classes.topics, classes.mLeft]}>
          {translate("ra.text.ci.selectCustomerType")}
        </Typography>
      </Box>
      <Box className={classes.container}>
        <Button
          className={classes.buttonContainer}
          onClick={() => {
            history.push({
              pathname: "/ci/member/search",
            });
          }}
        >
          <Box>
            <CardMedia
              image={MemberIcon}
              className={classes.bigIconwithTextContainer_icon}
            />

            <Typography className={classes.textStyle} align="center">
              {translate("ra.text.ci.member")}
            </Typography>
          </Box>
        </Button>
        <Box style={{ width: 20 }} />
        <Button
          className={classes.buttonContainer}
          onClick={() => {
            history.push({
              pathname: "/ci/potential/search",
            });
          }}
        >
          <Box>
            <HelpIcon className={classes.icon} />
            <Typography className={classes.textStyle}>
              {translate("ra.text.ci.potential")}
            </Typography>
          </Box>
        </Button>
      </Box>
      <PermissionChecker code="Page.Merchant.Customer_Insight" />
    </Box>
  );
}

export default CustomerInsightPage;
